import { Box, Column, Row, Tabs } from '@tempmee/react';
import { useMediaQuery } from '~/hooks';
import { fireOfficeTabClicked, fireProfessionalTabClicked } from '~/posthogs/events/Signup';
import { AuthLeftPanel, ProfessionalsTab, TESTIMONIALS, VALUE_PROPS } from '../shared';
import { SignUpForm } from './SignUpForm';

const HEADLINE = { lineOne: 'The Right Fit', lineTwo: 'Right Now' } as const;

// DS Row has no minHeight prop — fills viewport minus 64px header
const PAGE_STYLE = { minHeight: 'calc(100vh - 64px)' } as const;
// DS Column has no flex or minWidth props — left panel fills remaining space; minWidth:0 prevents flex blowout
const LEFT_PANEL_STYLE = { flex: 1, minWidth: 0 } as const;
// DS Row has no flex prop — form panel fills remaining space
const FORM_PANEL_STYLE = { flex: 1 } as const;
// DS Box has no maxWidth prop — caps form width on narrow screens
const FORM_BOX_STYLE = { maxWidth: '100%' } as const;

// onValueChange only fires when the user picks a different tab — covers the
// "user clicks tab" intent without firing on initial render or re-clicks on
// the same tab.
const handleTabChange = (value: string) => {
  if (value === 'offices') {
    fireOfficeTabClicked();
  } else if (value === 'professionals') {
    fireProfessionalTabClicked();
  }
};

export const SignUpPage = () => {
  const [isNarrow] = useMediaQuery(['sm']);

  return (
    <Row width="100%" align="stretch" style={PAGE_STYLE} data-testid="signup-page">
      {!isNarrow && (
        <Column style={LEFT_PANEL_STYLE}>
          <AuthLeftPanel headline={HEADLINE} valueProps={VALUE_PROPS} testimonials={TESTIMONIALS} />
        </Column>
      )}
      <Row align="start" justify="center" pt={16} pb={10} px={10} style={FORM_PANEL_STYLE}>
        <Box width="448px" style={FORM_BOX_STYLE}>
          <Tabs defaultValue="offices" onValueChange={handleTabChange}>
            <Row justify="center">
              <Tabs.List style={{ gap: 16 }}>
                <Tabs.Tab data-cy="tab-offices" value="offices">
                  Offices
                </Tabs.Tab>
                <Tabs.Tab data-cy="tab-professionals" value="professionals">
                  Professionals
                </Tabs.Tab>
              </Tabs.List>
            </Row>
            <Tabs.Panel value="offices">
              <SignUpForm />
            </Tabs.Panel>
            <Tabs.Panel value="professionals">
              <ProfessionalsTab />
            </Tabs.Panel>
          </Tabs>
        </Box>
      </Row>
    </Row>
  );
};
